import { AuthenticatedAccountPostsParams } from '../../../allSocialMediaPosts/api/getAllPosts';
import { CampaignsInsights } from '@app/types/api';
import { useQuery } from '@tanstack/react-query';
import sportsApi from '../../../utils/sportsApi';
import { CommonKey } from '../../../types/api';

const fetchCampaignsInsights = async (
    payload: AuthenticatedAccountPostsParams,
    clientId: number,
): Promise<CampaignsInsights> => {
    return await sportsApi
        .url(`/clients/${clientId}/campaigns/insights`)
        .json(payload)
        .post()
        .json();
};

const useCampaignsInsights = (
    payload: AuthenticatedAccountPostsParams,
    clientId: number,
) =>
    useQuery({
        queryKey: [CommonKey.CampaignsInsights, clientId],
        queryFn: (): Promise<CampaignsInsights> => fetchCampaignsInsights(payload, clientId),
    });

export default useCampaignsInsights;
